import React from 'react';
import ParentTemplate from '../components/ParentTemplate';
import Text from '../components/Text';
import BackButton from '../components/BackButton';
import { Link } from 'gatsby';

const NotFoundPage = () => (
  <ParentTemplate>
    <Text.H1 align="center">404 NOT FOUND</Text.H1>
    <Link to="/">
      <BackButton />
    </Link>
  </ParentTemplate>
);

export default NotFoundPage;
